// Legacy names are accepted only when opening existing saved rosters.
// The catalog and new rosters use names from the supplied rulebook.
export const armyNameAliases = {
  "Łowcy Czarownic": "Łowcy czarownic",
  "Elfowie Wysokiego Rodu z Ulthuan": "Elfowie Wysokiego Rodu z Ulthuanu",
  "Kompania Krasnoludzkich Piwowarów": "Kompania krasnoludzkich Piwowarów",
  "Jeźdzcy Wilków": "Jeźdźcy Wilków",
  "Nieumarła świta Hrabiego Von Carstein": "Nieumarła świta hrabiego von Carstein",
  "Nieumarły poczet Krwawych Smoków": "Nieumarły poczet Krwawego Smoka"
};

export const unitNameAliases = {
  "Cyrkowcy z Ligii Ostermarku": {
    "Magister magii": "Magister Magii"
  },
  "Muszkieterzy z Nuln": {
    "Magister magii": "Magister Magii",
    "Strażnik miejski": "Strażnik Miejski",
    "Krasnoludzki Ranger": "Krasnoludzki ranger"
  },
  "Piechota Morska z Marienburga": {
    "Kapłan Mannana": "Kapłan Mananna"
  },
  "Gladiatorzy z Jałowej Krainy": {
    "Pogromca Trolli": "Pogromca trolli"
  },
  "Siostry Sigmara": {
    "Siostra Bitwy": "Siostra bitwy",
    "Bitewny Ołtarz": "Bitewny ołtarz"
  },
  "Strażnicy dróg z Averlandu": {
    "Magister magii": "Magister Magii",
    "Pogromca Trolli": "Pogromca trolli"
  },
  "Zbrojna kompania z Ostlandu": {
    "Magister magii": "Magister Magii"
  },
  "Zbrojni z Middenheim": {
    "Magister magii": "Magister Magii"
  },
  "Żołnierze z Reiklandu": {
    "Magister magii": "Magister Magii"
  },
  "Rycerze Graala": {
    "Rycerz Próby": "Rycerz próby",
    "Rycerz Królestwa": "Rycerz królestwa",
    "Zbrojny Graala": "Zbrojny",
    "Błędny Rycerz": "Błędny rycerz"
  },
  "Piraci z Sartosy": {
    "Kapitan Piratów": "Kapitan piratów",
    "Kapłan Mannana": "Kapłan Mananna",
    "Żołnierz okrętowy": "Żołnierz Okrętowy"
  },
  "Psy Wojny": {
    "Oblężnik z Remas": "Oblężnik"
  },
  "Raubritterzy z Księstw Granicznych": {
    "Herszt Raubritterów": "Herszt raubritterów"
  },
  "Niziołki z Krainy Zgromadzenia": {
    "Magister magii": "Magister Magii"
  },
  "Leśni Elfowie z Athel Loren": {
    "Mag Elfów": "Mag elfów",
    "Strażnik Ścieżek": "Strażnik ścieżek",
    "Strażnik Polany": "Strażnik polany",
    "Tancerz Wojny": "Tancerz wojny",
    "Jeździec Polany": "Jeździec polany"
  },
  "Elfowie Wysokiego Rodu z Ulthuanu": {
    "Mag Elfów Wysokiego Rodu": "Mag elfów",
    "Mistrz Miecza Hoetha": "Mistrz Miecza Hoeth"
  },
  "Mroczni Elfowie z Naggaroth": {
    "Mroczny Pegaz": "Mroczny pegaz"
  },
  "Khazadzi z Gór Krańca Świata": {
    "Kowal Run": "Kowal run",
    "Mistrz Inżynier": "Mistrz inżynier",
    "Łamacz Żelaza": "Łamacz żelaza",
    "Wojownik Klanowy": "Wojownik klanowy",
    "Pogromca Trolli": "Pogromca trolli"
  },
  "Kompania krasnoludzkich Piwowarów": {
    "Mistrz Piwowar": "Mistrz piwowar",
    "Kowal Run": "Kowal run",
    "Mistrz Inżynier": "Mistrz inżynier",
    "Wojownik Klanowy": "Wojownik klanowy",
    "Krasnoludzki Ranger": "Krasnoludzki ranger",
    "Krasnoludzki Przepatrywacz": "Krasnoludzki przepatrywacz",
    "Pogromca Trolli": "Pogromca trolli"
  },
  "Kult Pogromców z Karak Kadrin": {
    "Tan Pogromców": "Tan pogromców",
    "Kowal Run": "Kowal run",
    "Mistrz Inżynier": "Mistrz inżynier",
    "Pogromca Smoków": "Pogromca smoków",
    "Pogromca Gigantów": "Pogromca gigantów",
    "Pogromca Trolli": "Pogromca trolli"
  },
  "Szkutnicy z Barak Varr": {
    "Mistrz Szkutnik": "Mistrz szkutnik",
    "Kowal Run": "Kowal run",
    "Mistrz Inżynier": "Mistrz inżynier",
    "Wojownik Klanowy": "Wojownik klanowy"
  },
  "Krasnoludowie Chaosu z Zorn Uzkul": {
    "Mistrz Inżynier": "Mistrz inżynier",
    "Wojownik Klanowy": "Wojownik klanowy"
  },
  "Jeźdźcy Wilków": {
    "Herszt Hobgoblinów": "Herszt hobgoblinów",
    "Szaman Hobgoblinów": "Szaman hobgoblinów",
    "Siepacz Hobgoblinów": "Siepacz hobgoblinów"
  },
  "Zwiadowcza kompania z Królestw Ogrów": {
    "Łowca": "Łowca (ogr)",
    "Ogniobrzuchy": "Ogniobrzuchy (ogr)",
    "Rzeźnik": "Rzeźnik (ogr)",
    "Żelazobrzuchy": "Żelazobrzuchy (ogr)",
    "Traper": "Traper (gnoblar)",
    "Zbrojny": "Zbrojny (Gnoblar)",
    "Byk": "Byk (ogr)"
  },
  "Kult Karmazynowej Czaszki": {
    "Piekielny Ogar": "Piekielny ogar"
  },
  "Kult Sybarytów": {
    "Bólożądna Pieszczota": "Bólożądna pieszczota"
  },
  "Kult Purpurowej Dłoni": {
    "Różowy Strachulec": "Różowy strachulec",
    "Smoczy Ogr": "Smoczy ogr"
  },
  "Grasanci Chaosu": {
    "Smoczy Ogr": "Smoczy ogr",
    "Rydwan Chaosu": "Rydwan"
  },
  "Karnawał Chaosu": {
    "Mistrz Karnawału": "Mistrz karnawału",
    "Piekielny Ogar": "Piekielny ogar",
    "Nurglingi": "Nurgling",
    "Bólożądna Pieszczota": "Bólożądna pieszczota",
    "Różowy Strachulec": "Różowy strachulec"
  },
  "Zbrojne stado Zwierzoludzi": {
    "Herszt Zwierzoludzi": "Herszt zwierzoludzi",
    "Szaman Zwierzoludzi": "Szaman zwierzoludzi"
  },
  "Nieumarła świta hrabiego von Carstein": {
    "Hrabia Von Carstein": "Hrabia von Carstein"
  },
  "Nieumarły poczet Krwawego Smoka": {
    "Krwawy Smok": "Krwawy smok",
    "Dreg": "Giermek",
    "Czarny Rycerz": "Czarny rycerz"
  },
  "Nieumarły sabat rodu Nekrarch": {
    "Czarna Karoca": "Czarna karoca"
  },
  "Nieumarły tabor ludu Strigosu": {
    "Czarna Karoca": "Czarna karoca"
  },
  "Nieumarła horda Liczmistrza": {
    "Czarny Rycerz": "Czarny rycerz"
  },
  "Nieumarły zastęp z Nehekhary": {
    "Książe Grobowców": "Książe grobowców",
    "Strażnik Grobowców": "Strażnik grobowców",
    "Nieumarły Nomada": "Nieumarły nomada",
    "Grobowy Skorpion": "Grobowy skorpion"
  },
  "Poganiacze klanu Moulder": {
    "Mistrz Mutator": "Mistrz mutator",
    "Mistrz Ciałokształtowania": "Mistrz ciałokształtowania"
  },
  "Kult Zarazy klanu Pestilens": {
    "Diakon Zarazy": "Diakon zarazy",
    "Mnich Zarazy": "Mnich zarazy",
    "Czciciel Zarazy": "Czciciel zarazy",
    "Siewca Zarazy": "Siewca zarazy",
    "Szczur Zarazy": "Szczur zarazy",
    "Czerw Zarazy": "Czerw zarazy"
  },
  "Harcownicy klanu Skryre": {
    "Koło Zagłady": "Koło zagłady"
  },
  "Zbrojne stado klanu Mors": {
    "Szary Prorok": "Szary prorok"
  },
  "Łowcze plemię Dzikich Orków": {
    "Szaman Dzikich Orków": "Szaman dzikich orków",
    "Burszuj Dzikich Orków": "Burszuj dzikich orków",
    "Dziki Ork": "Dziki ork",
    "Leśny Goblin": "Leśny goblin",
    "Dziki Ork na Dziku": "Dziki ork na dziku"
  },
  "Plemię Leśnych Goblinów": {
    "Herszt Leśnych Goblinów": "Herszt leśnych goblinów",
    "Szaman Leśnych Goblinów": "Szaman leśnych goblinów",
    "Traper Leśnych Goblinów": "Traper leśnych goblinów",
    "Rembajło Leśnych Goblinów": "Rembajło leśnych goblinów",
    "Leśny Goblin": "Leśny goblin",
    "Jeździec Pajonków": "Jeździec pajonków",
    "Wielki Pajonk": "Wielki pajonk"
  },
  "Orkowie & Gobliny": {
    "Herszt Orków": "Herszt orków",
    "Szaman Orków": "Szaman orków",
    "Burszuj Orków": "Burszuj orków",
    "Gobliński Fanatyk": "Gobliński fanatyk",
    "Ork na Dziku": "Ork na dziku"
  },
  "Nocne Gobliny": {
    "Herszt Nocnych Goblinów": "Herszt nocnych goblinów",
    "Szaman Nocnych Goblinów": "Szaman nocnych goblinów",
    "Sieciarz Nocnych Goblinów": "Sieciarz nocnych goblinów",
    "Nocny Goblin": "Nocny goblin",
    "Gobliński Fanatyk": "Gobliński fanatyk",
    "Nocny Hop-Goblin": "Nocny hop-goblin",
    "Wielki Squig": "Wielki squig"
  },
  "Załoga Zielonoskórych Kaprów": {
    "Kapitan Goblinów": "Kapitan goblinów",
    "Szaman Goblinów": "Szaman goblinów",
    "Goblin Mat": "Goblin mat",
    "Goblin Pirat": "Goblin pirat",
    "Ośmiornica Bagienna": "Ośmiornica bagienna"
  },
  "Jaszczuroludzie z Lustrii": {
    "Wódz Skinków": "Wódz skinków",
    "Kapłan Skinków": "Kapłan skinków",
    "Skink Kameleon": "Skink kameleon",
    "Jeździec Zimnokrwistych": "Jeździec zimnokrwistych",
    "Jeździec Terradonów": "Jeździec terradonów"
  }
};

export const getArmyName = (name) => armyNameAliases[name] || name;
export const getUnitName = (armyName, name) => unitNameAliases[getArmyName(armyName)]?.[name] || name;

export const normalizeRosterNames = (roster) => ({
  ...roster,
  armyType: getArmyName(roster.armyType),
  armyList: (roster.armyList || []).map((unit) => {
    if (unit.type === "Najemne Ostrze") return unit;
    const name = getUnitName(roster.armyType, unit.unitName);
    return {
      ...unit,
      unitName: name,
      ...(unit.unitDisplayName === unit.unitName ? { unitDisplayName: name } : {}),
    };
  }),
});
